import React from 'react';
import { useTable } from 'react-table';
import { Link } from 'react-router-dom';
import {ImageIllustration} from "../../Image/ImageIllustration";
import styles from "../../Table/ReactTableBase.module.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEdit, faExternalLink} from "@fortawesome/free-solid-svg-icons";
import ReactTableBase from "../../Table/ReactTableBase";
import BtnSwitch from "../../Button/BtnSwitch";
import stylesSwitch from "../../Button/BtnSwitch.module.css";
import RenderCellActif from "../../Table/RenderCellActif";
import {Field, Formik} from "formik";
import {getUtilisateurStatusIcon} from "../../../services/UserService";
import RenderCellSplit from "../../Table/RenderCellSplit";
import Routing from "../../../services/routing";
import DateService from "../../../services/DateService";

const ContratsTable = ({ contrats, putActifOpenModal = null, handleSubmitContratStatus = null }) => {
    const data = React.useMemo(() => contrats, [contrats]);

    const renderCellEntreprise = ({ row, value }) => {
        return <Link to={Routing.generate({
            route: Routing.routes.adminEntreprise,
            params: { entrepriseId: value.id }
        })}>{value.nom}</Link>;
    }

    const renderCellCreated = ({ value }) => {
        return DateService.formatDate(value);
    }

    const renderCellDate= ({ value, row }) => {
        return <Link to={Routing.generate({
            route: Routing.routes.adminContrat,
            params: { entrepriseId: row.original.entreprise.id, contratId: row.original.id }
        })} style={{ marginBottom: "10px", display: "flex", flexDirection: "row" }}>
            {DateService.formatFrenchDateWithoutTime(value)}
        </Link>
    }

    const renderCellActions = ({ row }) => {
        return (
            <div className={styles.actions}>
                <Link to={Routing.generate({
                    route: Routing.routes.adminContrat,
                    params: { entrepriseId: row.original.entreprise.id, contratId: row.original.id }
                })} style={{ marginBottom: "10px", display: "flex", flexDirection: "row" }}>
                    <FontAwesomeIcon icon={faExternalLink}/>
                    Détail
                </Link>
                <Link to={Routing.generate({
                    route: Routing.routes.adminContrat,
                    params: { entrepriseId: row.original.entreprise.id, contratId: row.original.id },
                    queryParams: { mode: 'creation' }
                })} style={{ marginBottom: "10px", display: "flex", flexDirection: "row" }}>
                    <FontAwesomeIcon icon={faEdit}/>
                    Modifier
                </Link>
                <Link to={Routing.generate({
                    route: Routing.routes.adminActivites,
                    params: { entrepriseId: row.original.entreprise.id, contratId: row.original.id },
                })}>
                    <FontAwesomeIcon icon={faExternalLink} />
                    Activités
                </Link>
            </div>
        );
    }

    const renderCellReferent = ({ row, value }) => {
        return <Link to={Routing.generate({
            route: Routing.routes.adminUtilisateur,
            params: { utilisateurId: row.original.referent.id }
        })}>{row.original.referent.prenom} {row.original.referent.nom}</Link>;
    }

    const renderCellStatus = ({ value, row }) => {
        return (
            <>
                <Formik
                    initialValues={{ status: value ?? "", id: row.original.id }}
                    onSubmit={async (values, {setSubmitting}) => {
                        await handleSubmitContratStatus(values, {setSubmitting}, row.original);
                    }}
                    enableReinitialize
                >
                    {({isSubmitting, setFieldValue, values, submitForm}) => {
                        const handleChange = (e) => {
                            const { name, value } = e.target;
                            setFieldValue(name, value, false);
                            submitForm();
                        };

                        return (
                            <div className={styles.selectContainer}>
                                {getUtilisateurStatusIcon(value)}
                                <Field as="select" name="status" onChange={handleChange} className={styles.select}>
                                    <option>
                                        -- Sélectionnez un statut --
                                    </option>
                                    <option value={"0"}>
                                        Prospection
                                    </option>
                                    <option value={"1"}>
                                        Activé
                                    </option>
                                    <option value={"2"}>
                                        En résiliation
                                    </option>
                                    <option value={"3"}>
                                        Résilié
                                    </option>
                                </Field>
                            </div>
                        );
                    }
                    }
                </Formik>
            </>
        );
    }

    const columns = [
            /*{
                Header: 'Id',
                accessor: 'id',
                Cell: renderCellId,
            },*/
            {
                Header: 'Label',
                accessor: 'label',
            },
            {
                Header: 'Début',
                accessor: 'date_start',
                Cell: renderCellDate,
            },
            {
                Header: 'Fin',
                accessor: 'date_end',
                Cell: renderCellDate,
            },
            {
                Header: 'Entreprise',
                accessor: 'entreprise',
                Cell: renderCellEntreprise,
            },
            {
                Header: 'Référent',
                accessor: row => row.referent?.nom || '',
                Cell: renderCellReferent,
            },
            {
                Header: 'Statut',
                accessor: 'status',
                Cell: renderCellStatus,
            },
            {
                Header: 'État',
                accessor: 'actif',
                isBoolean: true,
                Cell: (props) => <RenderCellActif {...props} putActifOpenModal={putActifOpenModal} />,
            },
            {
                Header: 'Crée le',
                accessor: 'date_created',
                Cell: renderCellCreated,
            },
            {
                Header: 'Actions',
                id: 'actions',
                Cell: renderCellActions,
            },
        ];

    return (
        <ReactTableBase dataSource={contrats} columnsData={columns} />
    );
};

export default ContratsTable;
